import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Shield, Download } from 'lucide-react'
import { adminApi } from '../../services/api'

export default function AdminAuditPage() {
  const [page, _setPage] = useState(1)

  const { data, isLoading } = useQuery({
    queryKey: ['audit-logs', { page }],
    queryFn: () => adminApi.getAuditLogs({ page }).then(r => r.data),
  })

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Logi audytu</h1>
          <p className="text-gray-500">Historia operacji w systemie</p>
        </div>
        <button className="btn-secondary">
          <Download className="w-4 h-4 mr-2" />
          Eksportuj CSV
        </button>
      </div>

      <div className="card">
        {isLoading ? (
          <div className="p-8 text-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto" />
          </div>
        ) : data?.items?.length ? (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Data</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Użytkownik</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Akcja</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Zasób</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {data.items.map((log) => (
                  <tr key={log.id} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">
                      {new Date(log.createdAt).toLocaleString('pl-PL')}
                    </td>
                    <td className="px-4 py-3 text-sm">{log.userName}</td>
                    <td className="px-4 py-3 text-sm">
                      <span className="px-2 py-1 bg-gray-100 rounded text-xs">
                        {log.action}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-sm">{log.resourceType}</td>
                    <td className="px-4 py-3 text-sm">
                      {log.isSuccess ? (
                        <span className="text-green-600">OK</span>
                      ) : (
                        <span className="text-red-600">Błąd</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="p-8 text-center text-gray-500">
            <Shield className="w-12 h-12 mx-auto text-gray-300 mb-4" />
            <p>Brak logów audytu</p>
          </div>
        )}
      </div>
    </div>
  )
}
